export default "__VITE_ASSET__DFAiKR3y__"